import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.addEventListener("DOMContentLoaded", function () {
  let gallery = document.querySelector(".new-grid");

  if (!gallery) {
    return; // Stop execution on pages without the gallery
  }

  gsap.registerPlugin(ScrollTrigger);

  let galleryHeight = gallery.scrollHeight - window.innerHeight;

  gsap.to(gallery, {
    y: -galleryHeight,
    ease: "none",
    scrollTrigger: {
      trigger: ".layout--masonry-gallery",
      start: "top top",
      end: "+=" + galleryHeight,
      scrub: 1,
      pin: true,
      anticipatePin: 1,
    },
  });
});
